(function () {
  // Product photo carousel: moves with a GPU transform (no scroll snapping),
  // so swipes follow the finger smoothly and vertical page scrolling is untouched.
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;
    var total = track.children.length;
    var counter = gallery.querySelector('[data-gallery-counter]');
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var current = 0;

    function clamp(i) { return Math.max(0, Math.min(total - 1, i)); }
    function place(px) { track.style.transform = 'translate3d(' + px + 'px,0,0)'; }
    function width() { return track.parentNode.clientWidth; }
    function goTo(i) {
      i = clamp(i);
      current = i;
      track.classList.remove('is-dragging');
      place(-i * width());
      if (counter) counter.textContent = (i + 1) + ' / ' + total;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === total - 1;
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        if (n === i) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
      });
    }

    var sx = 0, sy = 0, dx = 0, st = 0, mode = null, raf = 0;
    track.addEventListener('touchstart', function (e) {
      if (e.touches.length > 1) { mode = 'y'; return; }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; dx = 0; mode = null; st = Date.now();
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (mode === 'y') return;
      var x = e.touches[0].clientX - sx, y = e.touches[0].clientY - sy;
      if (!mode) {
        if (Math.abs(x) < 6 && Math.abs(y) < 6) return;
        mode = Math.abs(x) > Math.abs(y) ? 'x' : 'y';
        if (mode === 'y') return;
        track.classList.add('is-dragging');
      }
      dx = x;
      if ((current === 0 && dx > 0) || (current === total - 1 && dx < 0)) dx = dx / 3;
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; place(-current * width() + dx); });
    }, { passive: true });
    function end() {
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
      if (mode === 'x') {
        var fast = Date.now() - st < 250 && Math.abs(dx) > 20;
        var target = current;
        if (dx < -width() * 0.2 || (fast && dx < 0)) target = current + 1;
        else if (dx > width() * 0.2 || (fast && dx > 0)) target = current - 1;
        goTo(target);
      }
      mode = null;
    }
    track.addEventListener('touchend', end, { passive: true });
    track.addEventListener('touchcancel', end, { passive: true });

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-gallery-thumb'), 10)); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });
    window.addEventListener('resize', function () {
      track.classList.add('is-dragging');
      place(-current * width());
    });
    goTo(0);
  });

  // Comments carousel: drifts on its own, and visitors can swipe, drag,
  // trackpad-scroll or use the arrows to move it left or right.
  document.querySelectorAll('.reviews').forEach(function (section) {
    var rows = Array.prototype.map.call(section.querySelectorAll('[data-reviews-row]'), function (row) {
      return {
        el: row,
        track: row.querySelector('[data-reviews-track]'),
        duration: parseFloat(row.getAttribute('data-duration')) || 60,
        dir: parseFloat(row.getAttribute('data-direction')) || -1,
        x: 0, half: 0, v: 0, tween: null, dragging: false
      };
    });
    if (!rows.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hovering = false, resumeAt = 0, visible = true, last = 0, running = false;

    function measure() {
      rows.forEach(function (r) { r.half = r.track.scrollWidth / 2; });
    }
    function wrap(r) {
      if (!r.half) return;
      while (r.x <= -r.half) r.x += r.half;
      while (r.x > 0) r.x -= r.half;
    }
    function draw(r) { wrap(r); r.track.style.transform = 'translate3d(' + r.x + 'px,0,0)'; }
    function hold(ms) { resumeAt = Math.max(resumeAt, performance.now() + ms); }
    function cardStep(r) {
      var card = r.track.firstElementChild;
      if (!card) return 300;
      var gap = parseFloat(getComputedStyle(r.track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function nudge(sign) {
      var now = performance.now();
      rows.forEach(function (r) {
        var dist = cardStep(r) * sign;
        r.v = 0;
        r.tween = { from: r.x, to: r.x + dist, start: now, dur: 550 };
      });
      hold(3000);
      start();
    }

    function frame(now) {
      if (!running) return;
      var dt = Math.min((now - (last || now)) / 1000, 0.05);
      last = now;
      var auto = !reduce && !hovering && now >= resumeAt;
      rows.forEach(function (r) {
        if (r.dragging) return;
        if (r.tween) {
          var p = Math.min((now - r.tween.start) / r.tween.dur, 1);
          var e = 1 - Math.pow(1 - p, 3);
          r.x = r.tween.from + (r.tween.to - r.tween.from) * e;
          if (p >= 1) r.tween = null;
        } else if (Math.abs(r.v) > 5) {
          r.x += r.v * dt;
          r.v *= Math.pow(0.04, dt);
        } else {
          r.v = 0;
          if (auto && r.half) r.x += r.dir * (r.half / r.duration) * dt;
        }
        // keep tween endpoints consistent after wrapping
        var before = r.x;
        wrap(r);
        if (r.tween && before !== r.x) { var shift = r.x - before; r.tween.from += shift; r.tween.to += shift; }
        r.track.style.transform = 'translate3d(' + r.x + 'px,0,0)';
      });
      requestAnimationFrame(frame);
    }
    function start() {
      if (running || !visible) return;
      running = true; last = 0;
      requestAnimationFrame(frame);
    }
    function stop() { running = false; }

    rows.forEach(function (r) {
      var sx = 0, sy = 0, startX = 0, mode = null, lastX = 0, lastT = 0, vel = 0;
      function begin(x, y) {
        sx = x; sy = y; startX = r.x; mode = null; lastX = x; lastT = performance.now(); vel = 0;
        r.tween = null; r.v = 0;
      }
      function move(x, y) {
        var dx = x - sx, dy = y - sy;
        if (!mode) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          mode = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (mode === 'x') { r.dragging = true; r.el.classList.add('is-dragging'); }
        }
        if (mode !== 'x') return;
        var now = performance.now();
        if (now > lastT) vel = vel * 0.6 + ((x - lastX) / ((now - lastT) / 1000)) * 0.4;
        lastX = x; lastT = now;
        r.x = startX + dx;
        draw(r);
      }
      function end() {
        if (mode === 'x') {
          r.v = Math.max(-3000, Math.min(3000, vel));
          hold(2500);
        }
        r.dragging = false; mode = null;
        r.el.classList.remove('is-dragging');
      }

      r.el.addEventListener('touchstart', function (e) {
        if (e.touches.length > 1) return;
        begin(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true });
      r.el.addEventListener('touchmove', function (e) {
        if (e.touches.length > 1) return;
        move(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true });
      r.el.addEventListener('touchend', end, { passive: true });
      r.el.addEventListener('touchcancel', end, { passive: true });

      // Mouse drag on desktop
      r.el.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        e.preventDefault();
        begin(e.clientX, e.clientY);
        mode = 'x'; r.dragging = true; r.el.classList.add('is-dragging');
        function mm(ev) { move(ev.clientX, ev.clientY); }
        function mu() { window.removeEventListener('mousemove', mm); window.removeEventListener('mouseup', mu); end(); }
        window.addEventListener('mousemove', mm);
        window.addEventListener('mouseup', mu);
      });

      // Sideways trackpad scrolling
      r.el.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        e.preventDefault();
        r.tween = null; r.v = 0;
        r.x -= e.deltaX;
        draw(r);
        hold(2500);
      }, { passive: false });

      r.el.addEventListener('mouseenter', function () { hovering = true; });
      r.el.addEventListener('mouseleave', function () { hovering = false; });
    });

    var prevBtn = section.querySelector('[data-reviews-prev]');
    var nextBtn = section.querySelector('[data-reviews-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { nudge(1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { nudge(-1); });

    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start(); else stop();
      }, { rootMargin: '100px' }).observe(section);
    } else {
      start();
    }
  });

  // Size selection: update the label and price next to the picker
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var label = section.querySelector('[data-size-label]');
    var price = section.querySelector('[data-price]');
    var form = section.querySelector('[data-product-form]');
    var error = section.querySelector('[data-error]');
    section.querySelectorAll('input[type="radio"][name="id"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (label) label.textContent = input.dataset.title || '';
        if (price && input.dataset.price) price.innerHTML = input.dataset.price;
        if (error) error.hidden = true;
      });
    });
    if (form) {
      form.addEventListener('submit', function (e) {
        var radios = form.querySelectorAll('input[type="radio"][name="id"]');
        if (radios.length && !form.querySelector('input[type="radio"][name="id"]:checked')) {
          e.preventDefault();
          if (error) { error.textContent = 'Please select a size.'; error.hidden = false; }
        }
      });
    }
  });
})();
